import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { BulletList } from "./components/BulletList";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    display: "flex",
    marginBottom: 16
  },
  title: {
    fontWeight: 700
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: 8
  }
});

export const Employment = ({ employment, lastChild }) => {
  const { title, organization } = employment;

  const containerStyles = lastChild
    ? [styles.container, { marginBottom: 0 }]
    : styles.container;

  return (
    <View style={containerStyles}>
      <View style={styles.header}>
        <View>
          <Text style={styles.title}>
            {title}, {organization}
          </Text>
        </View>

        <View>
          <Text style={styles.started}>
            {employment.started} ⁠— {employment.finished}
          </Text>
        </View>
      </View>

      <View style={styles.body}>
        <Text>{employment.description}</Text>

        <BulletList>
          {employment.points.map((point, i) => (
            <BulletList.Item key={i}>{point}</BulletList.Item>
          ))}
        </BulletList>
      </View>
    </View>
  );
};
